<template>

    <div>
        <div class="modal fade" id="addBudgetModal" tabindex="-1" role="dialog">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true"><i class="fa fa-times"></i></span></button>
                        <h4 class="modal-title">Begrotings regel {{ edit === false ? 'toevoegen' : 'bewerken' }}</h4>
                    </div>
                    <div class="modal-body">
                        <div class="form-group">
                            <label for="name">Omschrijving</label>
                            <input id="name" maxlength="191" type="text" class="form-control" v-model="form.name" />
                        </div>
                        <div class="form-group">
                            <label>Categorie</label>
                            <v-select
                                :options="getCategories"
                                label="name"
                                v-model="selectedCategory"
                            ></v-select>
                        </div>
                        <div class="form-group">
                            <label>Maand</label>
                            <monthly-picker
                                dateFormat="MM-YYYY"
                                inputClass="text"
                                placeHolder="Selecteer"
                                v-model="form.date"
                                :min="minDate"
                            ></monthly-picker>
                        </div>
                        <div class="form-group">
                            <label>Herhalen</label>
                            <div class="input-group">
                                <input
                                    type="number"
                                    class="form-control"
                                    v-model="form.repeat"
                                />
                                <span class="input-group-addon">maanden</span>
                            </div>
                        </div>
                        <div class="form-group">
                            <label>Bedrag</label>
                            <money
                                v-model="form.amount"
                                v-bind="money"
                                class="form-control"
                            ></money>
                        </div>
                        <div class="form-group text-right">
                            <button
                                :disabled="!canSubmit"
                                @click="onSubmit"
                                class="btn btn-primary"
                            >
                                <i class="mdi mdi-plus"></i>
                                <span class="sr-only">Toevoegen</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>

    import axios from 'axios';
    import moment from 'moment';
    import Lang from '../../../Lang';
    import vSelect from 'vue-select';
    import MonthlyPicker from 'vue-monthly-picker';
    import {Money} from 'v-money';

    export default {

        components: {
            MonthlyPicker,
            vSelect,
            Money,
        },

        computed: {

            canSubmit() {
                return (this.selectedCategory !== null && this.selectedCategory.id) &&
                    this.form.amount > 0 &&
                    this.form.name !== '' &&
                    this.form.date !== null &&
                    false === this.posting;
            },

            getCategories() {
                let categories = [];

                this.categories.forEach(cat => {
                    if (cat.parent !== null) {
                        let parent = this.categories.filter(par => par.uuid === cat.parent)[0];
                        categories.push({
                            name:parent.name + ": " + cat.name,
                            id:cat.uuid,
                        });
                    }
                });

                return categories;
            },

            minDate() {
                return moment().startOf("year");
            },

            postData() {
                return {
                    category_id:this.selectedCategory !== null ? this.selectedCategory.id : null,
                    date:this.form.date.format("YYYY-MM-DD"),
                    budget:this.form.amount,
                    name:this.form.name,
                    repeat:this.form.repeat,
                };
            },

        },

        data() {
            return {
                edit:false,
                editurl:null,
                form: {
                    amount:0,
                    date:moment(),
                    name:'',
                    repeat:0,
                },
                lang:Lang,
                money: {
                    decimal: ',',
                    thousands: '.',
                    prefix: '€ ',
                    suffix: '',
                    precision: 2,
                    masked: false
                },
                posting:false,
                selectedCategory:null,
            }
        },

        methods: {

            closeModal() {
                $('#addBudgetModal').modal('hide');
            },

            onSubmit() {
                //post the form
                this.posting = true;
                axios.post(this.edit === true ? this.editurl : this.addBudgetUri, this.postData)
                .then(() => {
                    this.$snotify.success("De regel is " + (this.edit === true ? 'gewijzigd' : 'toegevoegd'));
                    this.resetForm();
                    this.closeModal();
                    this.$emit("reloadData");
                })
                .catch(() => this.$snotify.error("Er is een fout opgetreden bij het " + (this.edit === true ? 'wijzigen' : 'toevoegen') + " van de regel"))
                .finally(() => this.posting = false);
            },

            openModal() {
                if (this.edit !== true) {
                    this.resetForm();
                }
                $('#addBudgetModal').modal('show');
            },

            resetForm() {
                this.form = {
                    amount:0,
                    date:moment(),
                    name:'',
                    repeat:0,
                };
                this.selectedCategory = null;
                this.edit = false;
                this.editurl = null;
            },

            setAsEdit(budget, date, category_id) {
                this.resetForm();
                this.form.amount = budget.amount / 100;
                this.form.name = budget.name;
                this.form.date = date;
                this.edit = true;
                this.editurl = budget._links.edit;
                this.selectedCategory = this.getCategories.filter(cat => cat.id === category_id)[0];
            },

        },

        name: "BusinessBudgetFormModal",

        props: {
            addBudgetUri: {
                required:true,
                type:String,
            },
            categories: {
                required:true,
                type:Array,
            },
            startperiod: { required:true },
        },

    }

</script>
